import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { CARRIER_LANES_LIST_TABLE, CarrierLanesTable } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { CarrierDataFeedbackDialog } from '../../project/capacity-search-panel/carrier-data-feedback/carrier-data-feedback.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
	selector: 'app-carrier-lanes',
	templateUrl: './carrier-lanes.component.html',
	styleUrls: ['./carrier-lanes.component.scss'],
})
export class CarrierLanesComponent implements OnInit {
	@Input() lanesList = null;
	@Input() lanesLength = null;
	@Input() carrierid;
	@Input() carrier;
	@Input() isActions: boolean = true;
	@Input() inputConfig: any = {
		origin: true,
		trailerType: true,
		destination: true,
	};
	@Input() showfrequencyColumn: boolean = false;
	@Input() enableProjectSearch: boolean = false;
	@Input() lanePageSize = 20;

	@Output() pageNumber: EventEmitter<any> = new EventEmitter();
	@Output() lanesListUpdated: EventEmitter<any> = new EventEmitter();
	@Output() approveCarrierLane: EventEmitter<CarrierLanesTable> = new EventEmitter();

	lanesDataTable = new MatTableDataSource<CarrierLanesTable>([]);
	@ViewChild(MatPaginator) lanePaginator: MatPaginator;
	@ViewChild(MatSort) laneSort: MatSort;

	lanesColumns = [
		'origin',
		'destination',
		'trailerType',
		'confirmationDate',
		'backhaulAvailable',
		'actions',
	];
	isLaneUpdating = false;

	constructor(public utilService: UtilService, private dialog: MatDialog) {}

	ngOnInit() {
		this.initializePage();
		this.initializeSort();
		if (this.showfrequencyColumn) {
			this.lanesColumns.splice(4, 1, 'frequency');
		}
		if (this.utilService.isAccountTypeAdmin()) {
			this.lanesColumns.push('reviewed');
		}
	}

	ngOnChanges() {
		if (!this.utilService.isNullOrUndefined(this.lanesList) && this.lanesList.length > 0) {
			this.buildView();
		} else {
			this.lanesDataTable = new MatTableDataSource<CarrierLanesTable>(CARRIER_LANES_LIST_TABLE([]));
		}
		setTimeout(() => {
			this.initializeSort();
		});
	}

	buildView() {
		this.lanesDataTable = new MatTableDataSource<CarrierLanesTable>(
			CARRIER_LANES_LIST_TABLE(this.lanesList)
		);
	}

	initializePage() {
		this.lanesDataTable.paginator = this.lanePaginator;
	}

	initializeSort() {
		this.lanesDataTable.sort = this.laneSort;
	}

	getCarrierLanes() {
		this.pageNumber.emit(this.lanePaginator.pageIndex);
	}

	laneFeedback(element) {
		let laneSelected: any = Object.assign({}, element);
		laneSelected.businessName = this.carrier.businessName;
		laneSelected.firmMc = this.carrier.mc;
		laneSelected.firmDot = this.carrier.dot;
		const lane = this.lanesList.find((lane) => lane.id === element.id);
		if (lane) {
			laneSelected.origin = {
				city: lane.originCity,
				state: lane.originState,
			};
			laneSelected.destination = {
				city: lane.destCity,
				state: lane.destState,
			};
		}
		this.dialog.open(CarrierDataFeedbackDialog, {
			width: '900px',
			data: {
				lane: laneSelected,
				incorrectDataType: 'lane',
				carrier: this.carrier,
			},
		});
	}

	emitUpdatedLanesList() {
		this.lanesListUpdated.emit(this.lanesList);
		this.buildView();
	}

	showProgressBar() {
		return this.lanesList == null || this.isLaneUpdating;
	}

	isFrequencyValidNumber(frequency): boolean {
		return !/\D/.test(frequency);
	}

	carrierLaneApproved(carrierLaneTable: CarrierLanesTable) {
		carrierLaneTable.toBeReviewed = false;
		this.approveCarrierLane.emit(carrierLaneTable);
	}
}
